export default "__VITE_ASSET__sR765uf9__"